import { render, staticRenderFns } from "./CredenciamentoFornecedorDadosGerais.vue?vue&type=template&id=1315dce4"
import script from "./CredenciamentoFornecedorDadosGerais.vue?vue&type=script&lang=js"
export * from "./CredenciamentoFornecedorDadosGerais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports